import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    Index, CreateIndex, IndexCalculationType, CopyIndex,
    ContentItem, ReportPageItemType, ReportPageItemDto
} from 'app/shared/models';
import { forkJoin, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ConfigurationService } from 'app/shared/services/configuration.service';
import { ReportPageService } from '.';
import { toReportPageIndexKey } from 'app/admin-tpl/company-overview/reports/templates/default/index-report-page';

@Injectable({
    providedIn: 'root'
})
export class IndexService {
    constructor(private http: HttpClient, private config: ConfigurationService, private reportPageService: ReportPageService) {
    }
    list(): Observable<Index[]> {
        return this.http.get<Index[]>(`${this.config.apiUrl}/api/indexes`);
    }

    getByCompanyOrCore(companyId: number): Observable<Index[]> {
      return this.http.get<Index[]>(`${this.config.apiUrl}/api/indexes`, { params: { companyId: companyId}});
    }

    get(id: number): Observable<Index> {
        return this.http.get<Index>(`${this.config.apiUrl}/api/indexes/${id}`);
    }

    getForEdit(id: number): Observable<CreateIndex> {

        return this.http.get<CreateIndex>(`${this.config.apiUrl}/api/indexes/${id}/edit`);
    }

    update(model: CreateIndex) {
        return this.http.put<void>(`${this.config.apiUrl}/api/indexes/${model.indexId}`, model);
    }

    indexCalculationTypes(): Observable<IndexCalculationType[]> {
        return this.http.get<IndexCalculationType[]>(`${this.config.apiUrl}/api/indexes/calculationtypes`);
    }

    create(model: CreateIndex): Observable<Index> {
        return this.http.post<Index>(`${this.config.apiUrl}/api/indexes`, model);
    }

    copy(model: CopyIndex): Observable<Index> {
        return this.http.post<Index>(`${this.config.apiUrl}/api/indexes/copy`, model);
    }
    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(`${this.config.apiUrl}/api/indexes/${id}`);
    }
}
